var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay",style:(_vm.style),attrs:{"transition":"overlay-fade"},on:{"click":_vm.handlerClick,"touchmove":_vm.prevent}})
}
var staticRenderFns = []

export { render, staticRenderFns }